import React from 'react'
import AddEditUserForm from '../../../Components/AddEditUserForm/AddEditUserForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetUserByIdQuery, useUpdateUserMutation } from '../../../Store/Apis/manageUserApi';
import toast from 'react-hot-toast';
import Loader from '../../../Components/Loader/Loader';
import Error from '../../../Components/Error/Error';

const EditUser = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get('id');
  const userByIdApi = useGetUserByIdQuery({
    keyID: userId
  }, {skip: !userId});


  const userData = userByIdApi.isSuccess ? {
    id: userByIdApi.data.data[0].id,
    name: userByIdApi.data.data[0].username,
    roles: userByIdApi.data.data[0].roleId,
    outlet: userByIdApi.data.data[0].outletId,
    phoneNumber: userByIdApi.data.data[0].phone,
    email: userByIdApi.data.data[0].email,
    isActive: userByIdApi.data.data[0].isActive == 1 ? true : false,
  } : {}
  

  const [updateUser] = useUpdateUserMutation()
  const handleSubmit = (formData) => {
    console.log(formData)
    const body = {
      username: formData.name,
      password: formData.password,
      email: formData.email,
      outletId: formData.outlet,
      roleId: formData.roles,
      phone: formData.phoneNumber,      
    }

    updateUser(body).then((res) => {
      if (res?.data?.status === 1) {
        toast.success(res?.data?.message, { duration: 7000 });
        navigate("/manage-users/existing-users")
      } else {
        toast.error(res?.data?.message, { duration: 7000 })
      }
    });
  }

  return (
    <>
      <div class="row align-items-center justify-content-between mb-3">
        <div class="col">
          <h5 class="fw-500 text-white">{"View & Edit User"}</h5>
        </div>
      </div>
      {
        (userByIdApi.isError) && (
          <>
            <div className="card">
              <div className="card-body">
                <Error />
              </div>
            </div>
          </>
        )
      }
      {
        (userByIdApi.isLoading || userByIdApi.isFetching) && (
          <>
            <div className="card">
              <div className="card-body">
                <Loader height={500} />
              </div>
            </div>
          </>
        )
      }
      {
        userByIdApi.isSuccess && <AddEditUserForm userData={userData} onSubmit={handleSubmit} />
      }
      
    </>
  )
}

export default EditUser;